import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, UsersIcon } from 'lucide-react';
import { PLANS, PROMO } from '../data/site';
export function Tier3Memberships() {
  return <section className="w-full border-y border-ink-line bg-ink-soft py-16 sm:py-24" data-id="element-300" data-mp="14mzafbxekde0">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-301" data-mp="zwiw7plrcnql">
        <div className="mx-auto max-w-3xl text-center" data-id="element-302" data-mp="zuy03vjsowqm">
          <span className="inline-flex rounded-full bg-gradient-to-r from-brand-orange to-brand-red px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.18em] text-white shadow-lg shadow-brand-red/25 mb-4" data-id="element-303" data-mp="1dne717fthewt">
            Flagship Program
          </span>
          <h2 className="text-3xl uppercase sm:text-4xl" data-id="element-304" data-mp="1nlbs5m2dqvl7">Tier 3: The Sports Skills Program</h2>
          <p className="mt-4 text-white/75 text-lg" data-id="element-305" data-mp="1inth9q4sy6ak">
            Our most innovative program yet, featuring elite technical skills development and international methodology. Join the elite level of technical development.
          </p>
          <p className="mt-3 text-sm font-semibold text-brand-orange uppercase tracking-wide" data-id="element-306" data-mp="2ami6rjsdy7ar">
            {PROMO}
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-3 lg:items-center" data-id="element-307" data-mp="2fmedvrwdqeuj">
          {PLANS.map((plan, index) => <motion.div key={plan.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: index * 0.08
        }} className={`relative flex h-full flex-col rounded-3xl border p-7 ${plan.featured ? 'border-brand-orange/60 bg-ink shadow-2xl shadow-brand-red/20 lg:scale-105 z-10' : 'border-ink-line bg-ink'}`} data-id="element-308" data-mp="2jlwyemkagnwu" data-mpi={index}>
              {plan.featured && <span className="absolute -top-3 left-7 rounded-full bg-gradient-to-r from-brand-orange to-brand-red px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-white" data-id="element-309" data-mp="18yr20j4k50i6">
                  Most popular
                </span>}

              <h3 className="font-display text-2xl uppercase" data-id="element-310" data-mp="2bb4370rkyicd">{plan.name}</h3>
              <p className="mt-1 text-sm text-white/55" data-id="element-311" data-mp="2padcrhla6e7d">{plan.tagline}</p>

              <div className="mt-5" data-id="element-312" data-mp="2p893ek4m4mzp">
                <span className="inline-flex rounded-full bg-gradient-to-r from-brand-orange to-brand-red px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-white" data-id="element-313" data-mp="2l88pr1pc8ftp">
                  10% Off
                </span>

                <p className="mt-3 text-xs font-medium uppercase tracking-[0.14em] text-white/45" data-id="element-314" data-mp="2u8nd06lv44zu">
                  Regular price{' '}
                  <span className="line-through decoration-white/40" data-id="element-315" data-mp="3905p3tblpfdx">${plan.regularPrice}</span>
                </p>

                <p className="mt-1 flex items-end gap-1.5" data-id="element-316" data-mp="3hyrf29jejwoq">
                  <span className="pb-2 text-[11px] font-bold uppercase tracking-[0.18em] text-brand-orange" data-id="element-317" data-mp="3hzamgwbff2oi">
                    Now
                  </span>
                  <span className="bg-gradient-to-r from-brand-orange to-brand-red bg-clip-text font-display text-6xl leading-none text-transparent" data-id="element-318" data-mp="g2at1g4zeyz">
                    ${plan.price}
                  </span>
                  <span className="pb-1.5 text-sm font-medium text-white/50" data-id="element-319" data-mp="3nk01twzd9vnq">/mo</span>
                </p>
              </div>

              <p className="mt-5 inline-flex items-center gap-2 rounded-lg border border-ink-line bg-ink-card px-3 py-2 text-xs font-medium text-white/70" data-id="element-320" data-mp="3rl25cq0bgtvi">
                <UsersIcon className="h-4 w-4 text-brand-orange" aria-hidden="true" data-id="element-321" data-mp="3imgpx3q55uyy" />
                {plan.cap}
              </p>

              <ul className="mt-6 flex-grow space-y-3 text-sm text-white/75" data-id="element-322" data-mp="33ydjjt86sh9m">
                {plan.features.map(feature => <li key={feature} className="flex gap-3" data-id="element-323" data-mp="38tssq7v91ozp">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-324" data-mp="2uxp2epnhy0si" />
                    {feature}
                  </li>)}
              </ul>

              <a href={plan.ctaHref} target={plan.ctaHref.startsWith('#') ? undefined : '_blank'} rel={plan.ctaHref.startsWith('#') ? undefined : 'noreferrer'} className={`mt-8 block rounded-full px-6 py-3.5 text-center text-sm font-bold uppercase tracking-wide transition-transform hover:scale-[1.02] ${plan.featured ? 'bg-gradient-to-r from-brand-orange to-brand-red text-white shadow-lg shadow-brand-red/30' : 'border border-white/20 bg-white/5 text-white hover:bg-white/10'}`} data-id="element-325" data-mp="2mvy7ydtzkqfy">
                Join {plan.name}
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}